import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { useTelemetry } from '@/plugins/telemetry';
import { useStore } from '@/store/useStore';
import dayjs from 'dayjs';
export default defineComponent({
  name: 'LabsNavigation',
  props: {
    drawerState: {
      type: Boolean,
      required: true
    },
    onClickIcon: {
      type: Function,
      required: true
    }
  },
  setup: function setup(props) {
    var store = useStore();
    var telemetry = useTelemetry();
    var route = useRoute();
    var items = computed(function () {
      return store.state.persistent.labs.wandh.history;
    });
    var page = ref(1);
    var pagingSize = ref(0);
    var sentinel = ref(null);
    var loading = ref(false);
    var loadMore = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return store.dispatch('loadWandhHistory', {
                page: page.value,
                pagingSize: pagingSize.value
              });
            case 3:
              page.value++;
              loading.value = false;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function loadMore() {
        return _ref.apply(this, arguments);
      };
    }();
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        loadMore();
      }
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var viewportHeight, listItemHeight;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            store.dispatch('resetWandhHistory');

            // ビューポートの高さを取得し、それをリストアイテムの高さで割ってページングサイズを決定する
            // ただし、最低でも10件は取得する
            viewportHeight = window.innerHeight;
            listItemHeight = 65;
            pagingSize.value = Math.max(Math.floor(viewportHeight / listItemHeight), 10);
            _context2.next = 6;
            return loadMore();
          case 6:
            // sentinel要素を監視対象にする
            if (sentinel.value) {
              observer.observe(sentinel.value);
            }
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    onUnmounted(function () {
      observer.disconnect();
    });
    var formatCreatedAt = function formatCreatedAt(createdAt) {
      return dayjs(createdAt).format('YYYY/MM/DD HH:mm');
    };
    var handleItemClick = function handleItemClick(id) {
      telemetry.sendClickTelemetry({
        button: 'labs-wandh__history-item',
        params: {
          historyId: id
        }
      }, route);
    };
    return {
      props: props,
      items: items,
      sentinel: sentinel,
      formatCreatedAt: formatCreatedAt,
      loading: loading,
      handleItemClick: handleItemClick
    };
  }
});